import React from 'react';
import PropTypes from 'prop-types';
import { ImageWithFallback } from 'components';
import { placeholderLogo } from 'images';

export class AnimatedImage extends React.Component {
	static propTypes = {
		images: PropTypes.arrayOf(PropTypes.string),
		interval: PropTypes.number,
		className: PropTypes.string
	}

	static defaultProps = {
		interval: 2000
	}

	state = {
		showImg1: true,
		showImg2: false,
		indexImg1: 0,
		indexImg2: 0
	}

	componentDidMount() {
		const { interval } = this.props;
		this.timer = setInterval(this.animateImage, interval);
	}

	componentWillUnmount() {
		clearInterval(this.timer);
		clearTimeout(this.timeout);
	}

	animateImage = () => {
		const { interval } = this.props;
		const { showImg1, showImg2 } = this.state;
		this.setState({
			showImg1: !showImg1,
			showImg2: !showImg2
		});
		this.timeout = setTimeout(this.updateImage, interval / 2.0); //half of the interval such that image swapping is not seen by the user
	}

	updateImage = () => {
		const { showImg1, showImg2, indexImg1, indexImg2 } = this.state;
		const nextIndex1 = showImg1
			? indexImg1
			: (indexImg1 + 1) % this.getImg1Group().length;
		const nextIndex2 = showImg2
			? indexImg2
			: (indexImg2 + 1) % this.getImg2Group().length;
		this.setState({
			indexImg1: nextIndex1,
			indexImg2: nextIndex2
		});
	}

	getImg1Group = () => {
		const { images } = this.props;
		return images.filter((_, index) => index % 2 === 0);
	}

	getImg2Group = () => {
		const { images } = this.props;
		return images.filter((_, index) => index % 2 === 1);
	}

	getImg1 = () => {
		const imgs = this.getImg1Group();
		const { indexImg1 } = this.state;
		return imgs[indexImg1];
	}

	getImg2 = () => {
		const imgs = this.getImg2Group();
		const { indexImg2 } = this.state;
		return imgs[indexImg2];
	}

	render() {
		const { className } = this.props;
		const { showImg1, showImg2 } = this.state;
		return (
			<div className={className}>
				<ImageWithFallback
					className={`w-full h-full object-cover absolute top-0 left-0 slowTransition ${
						showImg1 ? 'opacity-100' : 'opacity-0'
					}`}
					src={this.getImg1()}
					fallback={placeholderLogo}
					alt="album cover" />
				<ImageWithFallback
					className={`w-full h-full object-cover absolute top-0 left-0 slowTransition ${
						showImg2 ? 'opacity-100' : 'opacity-0'
					}`}
					src={this.getImg2()}
					fallback={placeholderLogo}
					alt="album cover" />
			</div>
		);
	}
}

